import { RUN } from '../games/nganya/config/gameConfig';
import type { DailyChallengeConfig } from '../games/nganya/types';
import { dailySeed, dateKey } from '../games/nganya/utils/rng';

/**
 * Local daily challenge scaffolding.
 * Future Laravel: GET /api/games/nganya/daily-challenge
 */
export class LocalGameChallengeService {
  getToday(date = new Date()): DailyChallengeConfig {
    const key = dateKey(date);
    return {
      dateKey: key,
      seed: dailySeed(date),
      label: `Daily Dash · ${key}`,
      durationSec: RUN.durationSec,
      isLocalDemo: true,
    };
  }
}

export const gameChallengeService = new LocalGameChallengeService();

/**
 * Proposed Laravel contracts (not implemented):
 *
 * GET /api/games/nganya/daily-challenge
 * Response: { dateKey, seed, durationSec, title, rewardLabel? }
 *
 * POST /api/games/nganya/scores
 * Body: { mode, score, distance, fares, seed?, clientRunId, checksum? }
 * Response: { accepted, verifiedScore?, rank?, bestScore }
 *
 * GET /api/games/nganya/leaderboard?period=daily|all
 * Response: { entries: [{ rank, displayName, score, verified }] }
 *
 * GET /api/games/nganya/profile
 * Response: { bestScore, unlockedSkins, achievements, stats }
 *
 * Scores and entitlements must be server-verified before any reward claim.
 */
